<template>
  <v-container v-if="!sent">
    <v-layout>
      <v-flex class="text-center mt-8 mb-5">
        <h3 class="display-1">
          Resumo do questionário
        </h3>
      </v-flex>
    </v-layout>
    <ReviewQuestions :questions="questions" />
    <v-layout class="mt-8 mb-5">
      <v-spacer></v-spacer>
      <v-flex shrink>
        <v-img
          @click="$router.push('/')" :loading="loading"
          alt="Abracom"
          class="shrink mt-1"
          contain
          src="/img/editar.png"
          style="cursor:pointer"
          width="100px"
        />
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex shrink>
        <v-img
          @click="send" :loading="loading"
          alt="Abracom"
          class="shrink mt-1"
          contain
          style="cursor:pointer"
          src="/img/enviar.png"
          width="100px"
        />
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
    <v-dialog
      v-model="loading"
      persistent
      width="160"
    >
      <v-card
        color="white"
        class="py-10 text-center"
      >
        <v-card-text class="pa-0">
          <v-progress-circular
            indeterminate
            color="primary"
            class="mb-0"
          ></v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else>
    <v-layout row wrap  class="text-center mt-5">
      <v-flex xs12>
        <h3 >
          Recebemos seu questionário.
        </h3>
        <p class="grey--text">
          Uma cópia foi enviada para seu email.
        </p>
      </v-flex>
      <v-flex xs12 mt-5>
        <v-btn text color="primary" @click="$router.push('/')" large>
          Cadastrar uma nova concorrência
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ReviewQuestions from '@/components/ReviewQuestions'
import axios from 'axios'
export default {
  components: {
    ReviewQuestions
  },
  data () {
    return {
      loading: false,
      sent: false
    }
  },
  methods: {
    ...mapMutations('form', ['resetForm']),
    async send () {
      try {
        this.loading = true
        const body = {
          html: this.getHtml(),
          answers: this.getAnswers()
        }
        await axios.post('/SalvaQuestionario', body)
        this.resetForm()
        this.loading = false
        this.sent = true
      } catch (error) {
        console.log(error)
        this.loading = false
        this.$store.commit('snackbar/show', {
          text: 'Erro interno, tente novamente',
          color: 'error'
        })
      }
    },
    getHtml () {
      return document.getElementById('html').outerHTML
    },
    getAnswers () {
      const answers = {}
      this.questions.forEach(question => {
        if (question.field === 'inicioConcorrencia') {
          answers[question.field] = `${question.value.split('-')[1]}/${question.value.split('-')[0]}`
        } else {
          answers[question.field] = question.value
        }
      })
      return answers
    }
  },
  computed: {
    ...mapGetters('form', ['questions'])
  }
}
</script>

<style>
</style>
